import { FormControl, FormHelperText, OutlinedInput } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { ISelectFieldProps } from "../SingleSelectField";

interface SingleFieldProps extends ISelectFieldProps {
  value?: string;
  isReset?: boolean;
  className?: string;
  maxLength?: number;
}
export const NumberInput: React.FC<SingleFieldProps> = props => {
  const {
    disabled,
    label,
    value,
    onChange,
    name,
    hint,
    required,
    placeholder,
    error,
    isReset,
    className = "",
    maxLength,
    id
  } = props;

  const [textValue, setValue] = useState(value);

  const handleOnPaste = event => {
    event.preventDefault(); // Prevent default paste behavior
    const currentValue = event.clipboardData.getData("Text");
    if (
      !currentValue ||
      (new RegExp("^[0-9]*$").test(currentValue) &&
        (currentValue.length <= maxLength || !maxLength))
    ) {
      setValue(currentValue);
    } else {
      event.preventDefault();
    }
  };

  const handleChange = event => {
    const currentValue = event.target.value;
    if (
      !currentValue ||
      (new RegExp("^[0-9]*$").test(currentValue) &&
        (currentValue.length <= maxLength || !maxLength))
    ) {
      setValue(currentValue);
    } else {
      event.preventDefault();
    }
  };

  useEffect(() => {
    setValue(value);
  }, [value]);

  useEffect(() => {
    onChange({
      target: {
        name,
        value: textValue
      }
    });
  }, [textValue]);

  useEffect(() => {
    if (isReset) {
      setValue("");
    }
  }, [isReset]);

  return (
    <FormControl className="fullWidth" error={error} disabled={disabled}>
      <label className="text-xs font-semibold text-color-base pb-1">
        {label} {required ? <span className="text-primary">*</span> : ""}
      </label>
      <OutlinedInput
        aria-describedby="outlined-weight-helper-text"
        autoComplete="off"
        error={error}
        value={textValue}
        name={name}
        id={id}
        data-testid={id}
        placeholder={placeholder}
        onChange={handleChange}
        onPaste={handleOnPaste}
        inputProps={{
          onKeyDown: handleChange,
          "data-testid": `${id}-input`
        }}
        className={className}
      />
      {hint && <FormHelperText>{hint}</FormHelperText>}
    </FormControl>
  );
};
export default NumberInput;
